import { observer } from 'mobx-react';
import { FC } from 'react';
import MealComboGroup from '../../components/MealComboGroup/MealComboGroup';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';

const MealComboItemsBlock: FC = observer((): JSX.Element => {
  const { product, currentSizeGroups } = orderProductModalStore;

  // an empty block is needed for work parent justify-content-between
  if (!product?.items || !product.size) return <div></div>;

  return (
    <ScrollableBlock showScrollbar scrollbarSize="small" className="full-height mt-4 mr-6" scrollClassName="product-block d-flex flex-column px-6">
      {currentSizeGroups.map((group) => (
        <MealComboGroup key={String(group.id) + '-meal-group'} group={group} comboSize={product?.size} />
      ))}
    </ScrollableBlock>
  );
});

export default MealComboItemsBlock;
